import { getContext } from '@/context';

const AUTO_OPEN_STORAGE_KEY = 'genai.streak.auto-opened.v1';

const loadAnnouncedClaimId = (): string | null => {
  try {
    const savedKeys = getContext().internals.getState({ permanent: true });
    return savedKeys[AUTO_OPEN_STORAGE_KEY];
  } catch {
    return null;
  }
};

const saveAnnouncedClaimId = (claimId: string): void => {
  try {
    const current = getContext().internals.getState({ permanent: true });
    getContext()
      .internals.setState(
        { ...current, [AUTO_OPEN_STORAGE_KEY]: claimId },
        { permanent: true }
      )
      .catch(() => {
        // Best-effort persistence — losing it only re-announces once.
      });
  } catch {
    // Best-effort persistence — losing it only re-announces once.
  }
};

export { loadAnnouncedClaimId, saveAnnouncedClaimId };
